export default function HomeController() {
  const vm = this;

  return vm;
}

HomeController.$inject = [];
